

    export class GameTitle extends Phaser.Group {

        private chicken: Phaser.Image;
        private leftGO: Phaser.Image;
        private rightGO: Phaser.Image;
        private f: number;

        constructor(game: Phaser.Game) {

            super(game, null, "game-title");

            this.y = -125;
            this.f = 0;

            this.chicken = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "game-title-chicken.png");
            this.chicken.anchor.set(.5);
            this.add(this.chicken);

            this.leftGO = new Phaser.Image(this.game, -162, -45, "texture_atlas_1", "game-title-go-left.png");
            this.leftGO.anchor.set(.5);
            this.add(this.leftGO);

            this.rightGO = new Phaser.Image(this.game, 136, 54, "texture_atlas_1", "game-title-go-right.png");
            this.rightGO.anchor.set(.5);
            this.add(this.rightGO);

            this.scaleLeftGo();
        }

        public update(): void {

            super.update();

            this.f ++;

            if (this.f === 120) {

                this.f = 0;
                this.game.add.tween(this.chicken)
                    .to({angle: 1.5}, 125, Phaser.Easing.Cubic.InOut, true, 0, 0, true);
            }
        }

        private scaleLeftGo(): void {

            this.game.add.tween(this.rightGO.scale)
                .to({x: 1, y: 1}, 300, Phaser.Easing.Cubic.In, true);

            this.game.add.tween(this.leftGO.scale)
                .to({x: 1.07, y: 1.07}, 150, Phaser.Easing.Cubic.Out, true, 250)
                .onComplete.add(this.scaleRightGo, this);
        }   

        private scaleRightGo(): void {

            this.game.add.tween(this.leftGO.scale)
                .to({x: 1, y: 1}, 300, Phaser.Easing.Cubic.In, true);

            this.game.add.tween(this.rightGO.scale)
                .to({x: 1.07, y: 1.07}, 150, Phaser.Easing.Cubic.Out, true, 250)
                .onComplete.add(this.scaleLeftGo, this);
        }
    }
